unit unit_AbmeldungNewsletter;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, Vcl.Controls, WEBLib.Grids, Vcl.StdCtrls,
  WEBLib.StdCtrls, XData.Web.JsonDataset, XData.Web.Dataset;

type
  TAbmeldungNewsletter = class(TForm)
    TC: TTableControl;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsProtokoll: TXDataWebDataSet;
    xdsProtokollID: TIntegerField;
    xdsProtokollDatum: TDateTimeField;
    xdsProtokollKundennummer: TStringField;
    xdsProtokollNotiz: TStringField;
    xdsProtokollPruefungErforderlich: TBooleanField;
    xdsProtokollPruefungErledigt: TDateTimeField;
    xdsProtokollPruefungErledigtDurch: TStringField;
    xdsProtokollBemerkung: TStringField;
    xdsAnsprechpartner: TXDataWebDataSet;
    xdsAnsprechpartnerAPID: TStringField;
    xdsAnsprechpartnerKeinNewsletter: TBooleanField;
    xdsAnsprechpartnerEMail: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsProtokollAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsAnsprechpartnerAfterOpen(DataSet: TDataSet);
    procedure xdsAnsprechpartnerAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    AbmKundennummer:string;
    AbmEmail:string;
    AbmAPID:string;
    buttonzurueck:TButton;
    procedure buttonzurueckclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  AbmeldungNewsletter: TAbmeldungNewsletter;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TAbmeldungNewsletter.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAbmeldungNewsletter.WebFormShow(Sender: TObject);
begin
  xdsProtokoll.Close;
  xdsProtokoll.Load;
end;

procedure TAbmeldungNewsletter.xdsAnsprechpartnerAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

  if info.Records[0].Error='' then
  begin
    TC.Cells[0,2]:='<h6>Wir haben Ihre Abmeldung von unserem Newsletter in unserer Datenbank vermerkt. Über unser Kundenportal können Sie unseren Newsletter jederzeit wieder bestellen.';
  end;
end;

procedure TAbmeldungNewsletter.xdsAnsprechpartnerAfterOpen(DataSet: TDataSet);
begin
  if xdsAnsprechpartnerAPID.AsString=AbmAPID then
  begin
    xdsAnsprechpartner.Edit;
    xdsAnsprechpartnerKeinNewsletter.AsBoolean:=true;
    xdsAnsprechpartner.Post;
    xdsProtokoll.Append;
    xdsProtokollDatum.AsDateTime:=date+time;
    xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
    xdsProtokollNotiz.AsString:='Newsletter abbestellt '+abmEmail+' '+InternetIpAdresse;
    xdsProtokoll.Post;
    xdsProtokoll.ApplyUpdates;
    xdsansprechpartner.ApplyUpdates;
  end
  else
  begin
    TC.Cells[0,2]:='<h6>Wir konnten leider Ihre Kundennummer/Email bei uns finden. Bitte versuchen Sie es später nochmals.';
  end;
end;

procedure TAbmeldungNewsletter.xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

  if info.Records[0].Error='' then
  begin
    TC.Cells[0,2]:='<h6>Wir haben Ihre Abmeldung von unserem Newsletter in unserer Datenbank vermerkt. Über unser Kundenportal können Sie unseren Newsletter jederzeit wieder bestellen.';
  end;

end;

procedure TAbmeldungNewsletter.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  if xdsKundendatenKundennummer.AsString=AbmKundennummer then
  begin
    xdsKundendaten.Edit;
    xdsKundendatenKeinNewsletter.AsBoolean:=true;
    xdsKundendaten.Post;
    xdsProtokoll.Append;
    xdsProtokollDatum.AsDateTime:=date+time;
    xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
    xdsProtokollNotiz.AsString:='Newsletter abbestellt  '+abmEmail+' '+InternetIpAdresse;
    xdsProtokoll.Post;
    xdsProtokoll.ApplyUpdates;
    xdsKundendaten.ApplyUpdates;
  end
  else
  begin
    TC.Cells[0,2]:='<h6>Wir konnten leider Ihre Kundennummer/Email bei uns finden. Bitte versuchen Sie es später nochmals.';
  end;
end;

procedure TAbmeldungNewsletter.xdsProtokollAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=1;
  TC.RowCount:=4;
  i:=0;
  TC.Cells[0,i]:='<h4>Abmeldung vom Newsletter';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='<h6>Wir verarbeiten gerade Ihre Newsletter-Abmeldung ...';
  if (AbmAPID<>'') AND (AbmAPID<>'00000000-0000-0000-0000-000000000000') then
  begin
    //Ansprechpartner abmelden
      xdsAnsprechpartner.Close;
      xdsAnsprechpartner.QueryString:='$filter=APID eq '+QuotedStr(AbmAPID);
      xdsAnsprechpartner.Load;
  end
  else
  begin
    if AbmKundennummer<>'' then
    begin
      xdsKundendaten.Close;
      xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(AbmKundennummer);
      xdsKundendaten.Load;
    end;
  end;
end;

procedure TAbmeldungNewsletter.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsProtokoll := TXDataWebDataSet.Create(Self);
  xdsProtokollID := TIntegerField.Create(Self);
  xdsProtokollDatum := TDateTimeField.Create(Self);
  xdsProtokollKundennummer := TStringField.Create(Self);
  xdsProtokollNotiz := TStringField.Create(Self);
  xdsProtokollPruefungErforderlich := TBooleanField.Create(Self);
  xdsProtokollPruefungErledigt := TDateTimeField.Create(Self);
  xdsProtokollPruefungErledigtDurch := TStringField.Create(Self);
  xdsProtokollBemerkung := TStringField.Create(Self);
  xdsAnsprechpartner := TXDataWebDataSet.Create(Self);
  xdsAnsprechpartnerAPID := TStringField.Create(Self);
  xdsAnsprechpartnerEMail := TStringField.Create(Self);
  xdsAnsprechpartnerKeinNewsletter := TBooleanField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsProtokoll.BeforeLoadDFMValues;
  xdsProtokollID.BeforeLoadDFMValues;
  xdsProtokollDatum.BeforeLoadDFMValues;
  xdsProtokollKundennummer.BeforeLoadDFMValues;
  xdsProtokollNotiz.BeforeLoadDFMValues;
  xdsProtokollPruefungErforderlich.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigt.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigtDurch.BeforeLoadDFMValues;
  xdsProtokollBemerkung.BeforeLoadDFMValues;
  xdsAnsprechpartner.BeforeLoadDFMValues;
  xdsAnsprechpartnerAPID.BeforeLoadDFMValues;
  xdsAnsprechpartnerEMail.BeforeLoadDFMValues;
  xdsAnsprechpartnerKeinNewsletter.BeforeLoadDFMValues;
  try
    Name := 'AbmeldungNewsletter';
    Width := 390;
    Height := 480;
    Caption := 'DM2.XDataWebConnection1';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 281;
    TC.Height := 480;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    TC.Footer.ButtonElementClassName := 'btn btn-light';
    TC.Footer.DropDownElementClassName := 'form-control';
    TC.Footer.InputElementClassName := 'form-control';
    TC.Footer.LinkActiveElementClassName := 'link-primary';
    TC.Footer.LinkElementClassName := 'link-secondary';
    TC.Footer.ListElementClassName := 'pagination';
    TC.Footer.ListItemElementClassName := 'page-item';
    TC.Footer.ListLinkElementClassName := 'page-link';
    TC.Header.ButtonActiveElementClassName := 'btn btn-primary';
    TC.Header.ButtonElementClassName := 'btn btn-light';
    TC.Header.DropDownElementClassName := 'form-control';
    TC.Header.InputElementClassName := 'form-control';
    TC.Header.LinkActiveElementClassName := 'link-primary';
    TC.Header.LinkElementClassName := 'link-secondary';
    TC.Header.ListElementClassName := 'pagination';
    TC.Header.ListItemElementClassName := 'page-item';
    TC.Header.ListLinkElementClassName := 'page-link';
    TC.Options.ScrollVertical := True;
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 296;
    xdsKundendaten.Top := 40;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsProtokoll.SetParentComponent(Self);
    xdsProtokoll.Name := 'xdsProtokoll';
    xdsProtokoll.AfterOpen := xdsProtokollAfterOpen;
    xdsProtokoll.EntitySetName := 'KundenportalProtokoll';
    xdsProtokoll.Connection := DM2.XDataWebConnection1;
    xdsProtokoll.QueryTop := 1;
    xdsProtokoll.Left := 296;
    xdsProtokoll.Top := 104;
    xdsProtokollID.SetParentComponent(xdsProtokoll);
    xdsProtokollID.Name := 'xdsProtokollID';
    xdsProtokollID.FieldName := 'ID';
    xdsProtokollDatum.SetParentComponent(xdsProtokoll);
    xdsProtokollDatum.Name := 'xdsProtokollDatum';
    xdsProtokollDatum.FieldName := 'Datum';
    xdsProtokollKundennummer.SetParentComponent(xdsProtokoll);
    xdsProtokollKundennummer.Name := 'xdsProtokollKundennummer';
    xdsProtokollKundennummer.FieldName := 'Kundennummer';
    xdsProtokollKundennummer.Size := 13;
    xdsProtokollNotiz.SetParentComponent(xdsProtokoll);
    xdsProtokollNotiz.Name := 'xdsProtokollNotiz';
    xdsProtokollNotiz.FieldName := 'Notiz';
    xdsProtokollNotiz.Size := 250;
    xdsProtokollPruefungErforderlich.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErforderlich.Name := 'xdsProtokollPruefungErforderlich';
    xdsProtokollPruefungErforderlich.FieldName := 'PruefungErforderlich';
    xdsProtokollPruefungErledigt.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigt.Name := 'xdsProtokollPruefungErledigt';
    xdsProtokollPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsProtokollPruefungErledigtDurch.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigtDurch.Name := 'xdsProtokollPruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.FieldName := 'PruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.Size := 50;
    xdsProtokollBemerkung.SetParentComponent(xdsProtokoll);
    xdsProtokollBemerkung.Name := 'xdsProtokollBemerkung';
    xdsProtokollBemerkung.FieldName := 'Bemerkung';
    xdsProtokollBemerkung.Size := 255;
    xdsAnsprechpartner.SetParentComponent(Self);
    xdsAnsprechpartner.Name := 'xdsAnsprechpartner';
    xdsAnsprechpartner.AfterApplyUpdates := xdsAnsprechpartnerAfterApplyUpdates;
    xdsAnsprechpartner.AfterOpen := xdsAnsprechpartnerAfterOpen;
    xdsAnsprechpartner.EntitySetName := 'Ansprechpartner';
    xdsAnsprechpartner.Connection := DM2.XDataWebConnection1;
    xdsAnsprechpartner.Left := 296;
    xdsAnsprechpartner.Top := 192;
    xdsAnsprechpartnerAPID.SetParentComponent(xdsAnsprechpartner);
    xdsAnsprechpartnerAPID.Name := 'xdsAnsprechpartnerAPID';
    xdsAnsprechpartnerAPID.FieldName := 'APID';
    xdsAnsprechpartnerAPID.Size := 38;
    xdsAnsprechpartnerEMail.SetParentComponent(xdsAnsprechpartner);
    xdsAnsprechpartnerEMail.Name := 'xdsAnsprechpartnerEMail';
    xdsAnsprechpartnerEMail.FieldName := 'EMail';
    xdsAnsprechpartnerEMail.Size := 50;
    xdsAnsprechpartnerKeinNewsletter.SetParentComponent(xdsAnsprechpartner);
    xdsAnsprechpartnerKeinNewsletter.Name := 'xdsAnsprechpartnerKeinNewsletter';
    xdsAnsprechpartnerKeinNewsletter.FieldName := 'KeinNewsletter';
  finally
    TC.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsProtokoll.AfterLoadDFMValues;
    xdsProtokollID.AfterLoadDFMValues;
    xdsProtokollDatum.AfterLoadDFMValues;
    xdsProtokollKundennummer.AfterLoadDFMValues;
    xdsProtokollNotiz.AfterLoadDFMValues;
    xdsProtokollPruefungErforderlich.AfterLoadDFMValues;
    xdsProtokollPruefungErledigt.AfterLoadDFMValues;
    xdsProtokollPruefungErledigtDurch.AfterLoadDFMValues;
    xdsProtokollBemerkung.AfterLoadDFMValues;
    xdsAnsprechpartner.AfterLoadDFMValues;
    xdsAnsprechpartnerAPID.AfterLoadDFMValues;
    xdsAnsprechpartnerEMail.AfterLoadDFMValues;
    xdsAnsprechpartnerKeinNewsletter.AfterLoadDFMValues;
  end;
end;

end.